// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProceedPaymentBanner-paymentBottomBannerContainer-GivdO {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: var(--background-primary);
    -webkit-box-shadow: 0px -1px 16px 0px var(--shadow-1);
            box-shadow: 0px -1px 16px 0px var(--shadow-1);
    padding: 24px 0;
    z-index: 1031;
    border-radius: 6px 6px 0 0;
}

.ProceedPaymentBanner-paymentBottomBannerWrapper-BLOoL {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: end;
        -ms-flex-pack: end;
            justify-content: flex-end;
    gap: 36px;
    grid-gap: 36px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

@media (max-width: 575px) {
    .ProceedPaymentBanner-paymentBottomBannerWrapper-BLOoL {
        gap: 24px;
        grid-gap: 24px;
    }

    .ProceedPaymentBanner-paymentBottomBannerContainer-GivdO {
        padding: 18px 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ProceedPaymentBanner/ProceedPaymentBanner.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,qCAAqC;IACrC,qDAA6C;YAA7C,6CAA6C;IAC7C,eAAe;IACf,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,qBAAyB;QAAzB,kBAAyB;YAAzB,yBAAyB;IACzB,SAAS;IACT,cAAc;IACd,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI;QACI,SAAS;QACT,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".paymentBottomBannerContainer {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    background: var(--background-primary);\n    box-shadow: 0px -1px 16px 0px var(--shadow-1);\n    padding: 24px 0;\n    z-index: 1031;\n    border-radius: 6px 6px 0 0;\n}\n\n.paymentBottomBannerWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 36px;\n    grid-gap: 36px;\n    flex-wrap: wrap;\n}\n\n@media (max-width: 575px) {\n    .paymentBottomBannerWrapper {\n        gap: 24px;\n        grid-gap: 24px;\n    }\n\n    .paymentBottomBannerContainer {\n        padding: 18px 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paymentBottomBannerContainer": `ProceedPaymentBanner-paymentBottomBannerContainer-GivdO`,
	"paymentBottomBannerWrapper": `ProceedPaymentBanner-paymentBottomBannerWrapper-BLOoL`
};
module.exports = ___CSS_LOADER_EXPORT___;
